// Helper function for deduplication
const getUniqueCourses = (colleges: any[], coursesIds: any[]): any[] => {
  const courseMap = new Map<number, any>();

  colleges.forEach((college) => {
    college.course?.forEach((course: any) => {
      if (course?.id && !courseMap.has(course.id)) {
        courseMap.set(course.id, course);
      }
    });
  });

  // If coursesIds is valid and not empty, filter the results
  if (Array.isArray(coursesIds) && coursesIds.length > 0) {
    const filteredCourses = [...courseMap.values()].filter((course) => coursesIds.includes(course.id));
    return filteredCourses;
  }

  // Return all unique courses if no filtering is needed
  return [...courseMap.values()];
};

// Helper function for location matching logic
const checkLocationMatch = (college: any, filterKey: string, filterValue: any): boolean => {
  switch (filterKey) {
    case 'city':
      return college.city?.city_url === filterValue?.city_url;

    case 'state':
      return college.state?.state_name === filterValue?.state_name;

    case 'country':
      if (filterValue?.country_name === 'Abroad') {
        return college.country?.country_url !== 'study-in-india';
      }
      return college.country?.country_url === filterValue?.country_url;

    default:
      return true;
  }
};

const updateCourses = (filterData: any, filterOptions: any, filterSecStreamData: any) => {
  const PRIORITY_KEYS = ['city', 'state', 'country'];
  const activeFilterKey = PRIORITY_KEYS.find((key) => filterOptions[key]) || '';
  const activeFilterValue = filterOptions[activeFilterKey];

  let coursesIds: any = [];

  if (filterOptions?.stream?.stream_name) {
    const filteredStreamData = filterSecStreamData?.find(
      (streamData: any) => streamData.stream_name === filterOptions?.stream?.stream_name,
    )?.courses;

    if (Array.isArray(filteredStreamData) && filteredStreamData.length > 0) {
      coursesIds = filteredStreamData.map((course) => course.id);
    }
  }

  const filteredColleges = filterData.filter((college: any) => {
    // Check location match based on priority key
    const locationMatch = checkLocationMatch(college, activeFilterKey, activeFilterValue);

    return locationMatch;
  });

  return getUniqueCourses(filteredColleges, coursesIds);
};

export default updateCourses;
